// extracted by mini-css-extract-plugin
module.exports = {"box":"HmGameVertical_box_2hG9o","game-list":"HmGameVertical_game-list_3NQl3","info":"HmGameVertical_info_2m_9b","download":"HmGameVertical_download_1uRXL"};